import type { ChatMessage } from '@/types/chats';
import { uid, iso } from './common';

export const MOCK_CHATS: ChatMessage[] = [
  { id: uid('m'), clientId: 'c1', from: 'client', text: 'Felt strong today!', createdAt: iso(), source: 'mock' },
  { id: uid('m'), clientId: 'c2', from: 'client', text: 'Sleep was rough.', createdAt: iso(), source: 'mock' },
];

export const getMockChatForClient = (clientId: string): ChatMessage[] =>
  MOCK_CHATS.filter((m) => m.clientId === clientId);
